import {
  isClient,
  getAvailableQuantity,
  storageKey
} from 'reactjs/components/utility';

export const WATCHING_STATE = 'watching';
export const BUYING_STATE = 'buying';

export const getLowestPrice = (product) => {
  const prices = product.skus
    .filter((sku) => !sku.subsidiary)
    .map((sku) => sku.price);
  const lowestPrice = Math.min(...prices);
  return lowestPrice;
};

export const getClassifiedItems = (skus) => {
  /* eslint-disable no-param-reassign */
  const classifiedItems = skus.reduce((result, sku) => {
    if ({}.hasOwnProperty.call(result, sku.group)) {
      result[sku.group].push(sku);
    } else {
      result[sku.group] = [sku];
    }
    return result;
  }, {});
  /* eslint-disable no-param-reassign */
  Object.values(classifiedItems).forEach((group) => {
    group.sort((a, b) => a.position - b.position);
  });
  return classifiedItems;
};

const getMinimalPosition = (group) => {
  const positions = group.map((product) => product.position);
  const minimalPosition = Math.min(...positions);
  return minimalPosition;
};

export const getOrder = (group) => {
  return Object.keys(group).sort((groupA, groupB) => {
    const skuA = group[groupA];
    const skuB = group[groupB];
    return getMinimalPosition(skuA) - getMinimalPosition(skuB);
  });
};

export const getInitialItemIndex = (skus) => {
  for (let i = 0; i < skus.length; i += 1) {
    if (getAvailableQuantity(skus[i]) !== 0) {
      return i;
    }
  }
  return 0;
};

export const isProductSkusContainOrderSkus = (productSkus, orderSkus) => {
  const orderSkuIds = Object.keys(orderSkus).map((id) => Number(id));
  return productSkus.some((sku) => orderSkuIds.includes(sku.id));
};

export const getSelectedItemCount = (skuId) => {
  if (!isClient()) return 0;

  const skuInSessionStorage = sessionStorage.getItem(storageKey);
  if (!skuInSessionStorage) {
    return 0;
  }
  const selectedSkus = JSON.parse(skuInSessionStorage);
  return {}.hasOwnProperty.call(selectedSkus, skuId)
    ? selectedSkus[skuId].quantity
    : 0;
};

export const getRemainingLimitationCount = (skus) => {
  const counts = skus.reduce(
    (result, sku) => {
      return {
        remainCount:
          result.remainCount +
          (sku.remaining_inventory_count ? sku.remaining_inventory_count : 0),
        limitCount: result.limitCount + (sku.limitation ? sku.limitation : 0)
      };
    },
    { remainCount: 0, limitCount: 0 }
  );
  return counts;
};
